import React from "react";
import { Tabs, TabList, Tab, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import WriteComment from "../components/WriteComment";
import CommentBox from "../components/CommentBox";
import * as actions from "../../Comment/_redux/commentAction";
import ClipLoader from "react-spinners/ClipLoader";
import {
    initCommentSetting,
    setAvoidSpamLikePost
} from "./../_redux/commentSlice";
import SkeletonGroup from "./../components/SkeletonGroup";
import { setHeightLayout, createStyles } from "./../helpers";
import { useTranslation } from "react-i18next";
import queryString from "query-string";

const CommentsPage = () => {
    // __REDUX
    const { currentState } = useSelector(state => ({
        currentState: state.comment
    }));
    const {
        totalRow,
        pageSize,
        models,
        listLoading,
        commentSetting,
        actionsLoading,
        totalComment
    } = currentState;
    const dispatch = useDispatch();

    // __STATE
    const { t, i18n } = useTranslation();
    // current tab
    const [currentTab, setCurrentTab] = useState(2);
    // totalPage
    const [totalPage, setTotalPage] = useState(0);
    // currentPage
    const [currentPage, setCurrentPage] = useState(0);
    // setHeightLayout(0);
    // __EFFECT
    useEffect(() => {
        setTimeout(() => setHeightLayout(0), 100);
    }, [currentTab, listLoading]);

    // check models then post message to client
    useEffect(() => {
        if (models?.length == 0 || models == null) {
            window.parent.postMessage({ commentCounts: "empty" }, "*");
        }
    }, [models]);
    // effect setTotalRow
    // console.log(totalRow);
    useEffect(() => {
        if (totalRow && totalRow > 0 && pageSize) {
            setTotalPage(Math.ceil(totalRow / Number(pageSize) - 1));
        }
        if (totalRow) {
            window.parent.postMessage({ commentCounts: totalComment }, "*");
        }
    }, [totalRow, pageSize]);

    // effect change language and change theme
    useEffect(() => {
        if (commentSetting?.locale) {
            i18n.changeLanguage(commentSetting?.locale);
            // console.log(commentSetting);
        } else {
            i18n.changeLanguage("vi");
        }
        // create style in react tabs
        createStyles(
            ".comment__box",
            `
            .react-tabs__tab--selected {
                background: #fff ;
                border-color:unset !important;
                color: ${
                    commentSetting?.version &&
                    commentSetting?.version === "2.0.0"
                        ? commentSetting.commentConfiguration.themeConfig
                              .tabBlock.activeColor
                        : commentSetting?.theme?.backgroundColor
                } !important;
            }
            .react-tabs__tab--selected::after{
                content: "";
                position: absolute;
                width: 100%;
                height: 2px;
                background: ${
                    commentSetting?.version &&
                    commentSetting?.version === "2.0.0"
                        ? commentSetting.commentConfiguration.themeConfig
                              .tabBlock.activeColor
                        : commentSetting?.theme?.backgroundColor
                };
                bottom: -7px;
                left: 0px;
            }
            .react-tabs__tab>button:hover{
                color:${
                    commentSetting?.version &&
                    commentSetting?.version === "2.0.0"
                        ? commentSetting.commentConfiguration.themeConfig
                              .tabBlock.hoverColor
                        : commentSetting?.theme?.backgroundColor
                };
            }`
        );
    }, [commentSetting?.locale]);

    // effect này sẽ gọi request mỗi lần tab thay đổi
    useEffect(() => {
        if (commentSetting?.vnnSetting) {
            var request = {
                SortType: currentTab,
                objectId: commentSetting.objectId,
                pageIndex: 0
            };
            const locationParser = queryString.parse(window.location.search);
            if (locationParser?.commentId)
                request.commentId = locationParser.commentId;
            // has sourceType
            if (commentSetting?.sourceType)
                request.SourceType = commentSetting?.sourceType;
            dispatch(actions.commentGets(request));
            // console.log(request);
            // console.log(commentSetting);
        }
        setCurrentPage(0);
    }, [currentTab, commentSetting?.vnnSetting]);

    // effect này để lắng nghe message
    useEffect(() => {
        if (window.addEventListener) {
            window.addEventListener("message", onLoadData, false);
        } else {
            window.attachEvent("onmessage", onLoadData);
        }
        // cho nay la ban data len khi iframe khoi dong xong
        window.parent.postMessage({ commentIframeLoaded: true }, "*");
        // console.log(Math.round(Number("52.532")));
    }, []);

    // __FUNCTION HANDLE
    const onLoadData = function(event) {
        if (event.data?.vnnSetting) {
            // all data from parent
            if (
                event.data?.websiteId?.length > 0 &&
                event.data?.objectId?.length > 0
            ) {
                // init all setting push to redux
                // console.log(event.data);
                // trường hợp không sử dụng User_info
                if (
                    event.data.commentConfiguration.disableOverlayLogin === true
                ) {
                    event.data.userInfo = {};
                    event.data.isNotLogin = true;
                }
                // cha tao iframe -> iframe load xong -> con ban loaded len cha -> cha day data xuong
                // if(event.data.commentConfiguration.disableOverlayLogin)
                dispatch(initCommentSetting(event.data));
                window.$websiteId = event.data.websiteId;
            }
        }
        //avoid spam like and unlike
        if (event.data.maxLimitLikeAndUnlike) {
            window.parent.postMessage({ maxLimitLikeAndUnlike: true }, "*");
            dispatch(setAvoidSpamLikePost(event.data.maxLimitLikeAndUnlike));
        }
    };

    // button seeMore
    const onSeeMoreComment = () => {
        const pageIndex = currentPage;
        var request = {
            SortType: currentTab,
            objectId: commentSetting.objectId,
            pageIndex: pageIndex + 1
        };
        const locationParser = queryString.parse(window.location.search);
        if (locationParser?.commentId)
            request.commentId = locationParser.commentId;
        dispatch(actions.commentLoadMore(request));
        setCurrentPage(currentPage + 1);
    };
    // handle tab
    const onHandleTabs = index => {
        if (index == 1) return setCurrentTab(0);
        if (index == 2) return setCurrentTab(1);
        setCurrentTab(2);
    };
    // handle render jsx button see more
    const renderButtonSeeMore = () => {
        return (
            <button
                style={{
                    color:
                        commentSetting?.version &&
                        commentSetting?.version === "2.0.0"
                            ? commentSetting.commentConfiguration.themeConfig
                                  .seemoreCommentBlock.textColor
                            : commentSetting?.theme?.backgroundColor,
                    borderColor:
                        commentSetting?.version &&
                        commentSetting?.version === "2.0.0"
                            ? commentSetting.commentConfiguration.themeConfig
                                  .seemoreCommentBlock.borderColor
                            : commentSetting?.theme?.backgroundColor,
                    backgroundColor:
                        commentSetting?.version &&
                        commentSetting?.version === "2.0.0" &&
                        commentSetting.commentConfiguration.themeConfig
                            .seemoreCommentBlock.backgroundColor
                }}
                onClick={onSeeMoreComment}
                className='mx-auto rounded-[5px] items-center flex
                            text-[16px] justify-center border-[1px] p-[10px] pb-[7px] pt-[4px] font-arial font-semibold font-weight-none sm:font-notosans-bold'>
                {actionsLoading && (
                    <ClipLoader
                        size={20}
                        color={commentSetting?.theme?.backgroundColor}
                    />
                )}
                <span className='mr-[8px] ml-[5px] transform translate-y-[2px]'>
                    {t("message.seemoreComments")}
                </span>
                <i
                    style={{
                        borderColor:
                            commentSetting?.version &&
                            commentSetting?.version === "2.0.0"
                                ? commentSetting.commentConfiguration
                                      .themeConfig.seemoreCommentBlock.textColor
                                : commentSetting?.theme?.backgroundColor
                    }}
                    className='arrow down'></i>
            </button>
        );
    };
    const [heightBoxComment, setHeightBoxComment] = useState(null);
    // console.log("commentSetting : ", commentSetting);
    // __RENDER
    return (
        <div
            className={`bg-white sm:font-notosans-regular font-arial comment__box text-[14px] ${
                commentSetting.classNames ? commentSetting.classNames : ""
            }`}>
            <div
                style={{
                    color:
                        commentSetting?.version &&
                        commentSetting?.version === "2.0.0"
                            ? commentSetting.commentConfiguration.themeConfig
                                  .titlePrimaryColor
                            : commentSetting?.theme?.backgroundColor
                }}
                className='title text-[18px] font-arial font-semibold font-weight-none sm:font-notosans-bold mb-[10px] uppercase '>
                {t("message.mainTitle")}{" "}
                {models && models.length > 0 ? (
                    <span>({totalComment})</span>
                ) : null}
            </div>
            <WriteComment
                handleCalcHeightBoxComment={value =>
                    setHeightBoxComment(`${value + 114}px`)
                }
            />
            {models?.length == 0 || models == null ? (
                <div className='flex h-[100px] justify-center items-center  gap-[10px]'>
                    <div>
                        <img
                            className='w-[40px] '
                            src='https://static.vnncdn.net/v1/icon/comment-gray.svg'
                            alt='Hình ảnh khi không có bình luận'
                        />
                    </div>
                    <div className='px-[10px] w-[275px] text-[#797979] text-[16px] '>
                        {t("message.noComment")}
                    </div>
                </div>
            ) : (
                <React.Fragment>
                    <Tabs onSelect={onHandleTabs}>
                        <TabList>
                            {/* tab list  for desktop */}
                            <div
                                style={{
                                    justifyContent:
                                        commentSetting?.version &&
                                        commentSetting?.version === "2.0.0" &&
                                        commentSetting.commentConfiguration
                                            .themeConfig.tabBlock.justifyContent
                                }}
                                className='sidebar flex justify-end mb-[10px] pb-[6px] border-b-[2px] border-[#CCC] '>
                                <Tab>
                                    <button className='text-[14px] font-arial sm:font-notosans-regular sm:text-[15px] relative sm:px-[15px]'>
                                        {t("message.tabs.newest")}
                                    </button>
                                </Tab>
                                <Tab>
                                    <button className='text-[14px] font-arial sm:font-notosans-regular sm:text-[15px] relative sm:px-[15px]'>
                                        {t("message.tabs.mostInterested")}
                                    </button>
                                </Tab>
                                <Tab>
                                    <button className='text-[14px] font-arial sm:font-notosans-regular sm:text-[15px] relative sm:px-[15px]'>
                                        {t("message.tabs.oldest")}
                                    </button>
                                </Tab>
                            </div>
                        </TabList>
                        {listLoading == false && (
                            <div
                                className='wrapper__list--comment'
                                style={
                                    commentSetting.classNames &&
                                    heightBoxComment
                                        ? {
                                              top: heightBoxComment
                                          }
                                        : {}
                                }>
                                <TabPanel>
                                    {/* list comments */}
                                    <ul>
                                        {models &&
                                            models.map((commentItem, key) => {
                                                // check last Item de show box icon o vi tri thich hop
                                                if (key >= models.length - 3) {
                                                    return (
                                                        <CommentBox
                                                            key={key}
                                                            dataComment={
                                                                commentItem
                                                            }
                                                            currentTab={
                                                                currentTab
                                                            }
                                                            lastIndex={true}
                                                            lastIndexItem={
                                                                models.length
                                                            }
                                                            currentIndex={
                                                                key + 1
                                                            }
                                                        />
                                                    );
                                                }
                                                return (
                                                    <CommentBox
                                                        key={key}
                                                        dataComment={
                                                            commentItem
                                                        }
                                                        currentTab={currentTab}
                                                        lastIndexItem={
                                                            models.length
                                                        }
                                                        currentIndex={key + 1}
                                                    />
                                                );
                                            })}
                                    </ul>
                                </TabPanel>
                                <TabPanel>
                                    {/* list comments */}
                                    <ul>
                                        {models &&
                                            models.map((commentItem, key) => {
                                                // check last Item de show box icon o vi tri thich hop
                                                if (key >= models.length - 3) {
                                                    return (
                                                        <CommentBox
                                                            key={key}
                                                            dataComment={
                                                                commentItem
                                                            }
                                                            currentTab={
                                                                currentTab
                                                            }
                                                            lastIndex={true}
                                                            lastIndexItem={
                                                                models.length
                                                            }
                                                            currentIndex={
                                                                key + 1
                                                            }
                                                        />
                                                    );
                                                }
                                                return (
                                                    <CommentBox
                                                        key={key}
                                                        dataComment={
                                                            commentItem
                                                        }
                                                        currentTab={currentTab}
                                                        lastIndexItem={
                                                            models.length
                                                        }
                                                        currentIndex={key + 1}
                                                    />
                                                );
                                            })}
                                    </ul>
                                </TabPanel>
                                <TabPanel>
                                    {/* list comments */}
                                    <ul>
                                        {models &&
                                            models.map((commentItem, key) => {
                                                // check last Item de show box icon o vi tri thich hop
                                                if (key >= models.length - 3) {
                                                    return (
                                                        <CommentBox
                                                            key={key}
                                                            dataComment={
                                                                commentItem
                                                            }
                                                            currentTab={
                                                                currentTab
                                                            }
                                                            lastIndex={true}
                                                            lastIndexItem={
                                                                models.length
                                                            }
                                                            currentIndex={
                                                                key + 1
                                                            }
                                                        />
                                                    );
                                                }
                                                return (
                                                    <CommentBox
                                                        key={key}
                                                        dataComment={
                                                            commentItem
                                                        }
                                                        currentTab={currentTab}
                                                        lastIndexItem={
                                                            models.length
                                                        }
                                                        currentIndex={key + 1}
                                                    />
                                                );
                                            })}
                                    </ul>
                                </TabPanel>

                                {totalPage > 0 &&
                                    currentPage < totalPage &&
                                    commentSetting.classNames &&
                                    renderButtonSeeMore()}
                            </div>
                        )}
                    </Tabs>
                    {/* loading show is startCall */}
                    {listLoading && (
                        <React.Fragment>
                            <SkeletonGroup />
                            <SkeletonGroup />
                            <SkeletonGroup />
                        </React.Fragment>
                    )}
                    {/* skeleton test */}
                    {totalPage > 0 &&
                        currentPage < totalPage &&
                        !commentSetting.classNames &&
                        renderButtonSeeMore()}
                </React.Fragment>
            )}
        </div>
    );
};

export default CommentsPage;
